<div class="popup">
	<div class="popup-header">
		<h2>
			{{'SCHEDULE.REGISTER_SICK_DAY' | translate}}
		</h2>
		<div class="gold-text">
			{{data.date | smLocalDate:'mediumDate'}}
		</div>
	</div>
	<form
		[formGroup]="form"
		class="popup-body qo-padding30"
	>
		<qo-form-block
			[label]="'DAY_NOTES.NOTE' | translate"
		>
				<textarea
					class="qo-input"
					formControlName="message"
					placeholder=""
				></textarea>
		</qo-form-block>
		<div class="grey-text qo-margin-top30 qo-flex-row-top-left align-center">
			<qo-icon
				[icon]="EQORebrandIcon.info_dark"
				[color]="EQORebrandColor.SECONDARY"
				[size]="'sm'"
			></qo-icon>
			<div class="qo-margin-left5">
				{{'SICK_DAY.CREATE_INFO_TEXT' | translate}}
			</div>
		</div>
	</form>
	<div class="qo-flex-row-top-right qo-padding30 mobile-absolute">
		<button
			class="qo-button-standard qo-grey"
			(click)="close()"
		>
			{{ 'GLOBAL.CANCEL' | translate }}
		</button>
		<button
			class="qo-button-standard qo-primary qo-margin-left30"
			(click)="save()"
		>
			{{ 'GLOBAL.SAVE' | translate }}
		</button>
	</div>
</div>
